import React, { useState, useEffect } from 'react';
import { Segmented } from 'antd';
import PaymentTable from 'components/ManageSubscription/components/PaymentTable';
import InvoiceDraftTable from './components/InvoiceDraftTable';
import { getInvoiceCounts } from 'api/provider';
import { getGPInvoiceCounts } from 'api/group';
import DataUpdatedFlagStore from 'store/DataUpdatedFlag';
import s from './s.module.less';

interface Props {
    clientId?: number;
    state?: string;
    isGroupPractice?: boolean;
    useForModule?: boolean;
}

const Billing = ({ clientId, state, isGroupPractice, useForModule }: Props) => {
    const [activeTab, setActiveTab] = useState<string>('invoices');
    const [invoicesCount, setInvoicesCount] = useState<number>(0);
    const [draftsCount, setDraftsCount] = useState<number>(0);
    const [getDataUpdatedFlag] = DataUpdatedFlagStore.useStore();
    const billingDataUpdatedFlag = getDataUpdatedFlag('billingDataUpdated');

    const refreshCounts = React.useCallback(async () => {
        try {
            const res = isGroupPractice
                ? await getGPInvoiceCounts(clientId!)
                : await getInvoiceCounts(clientId!);
            if (!res.error && res.data?.data) {
                setInvoicesCount(res.data.data.listTotal || 0);
                setDraftsCount(res.data.data.draftListTotal || 0);
            }
        } catch (error) {
            console.error('Failed to fetch invoice counts:', error);
        }
    }, []);

    useEffect(() => {
        refreshCounts();
    }, [clientId, refreshCounts, billingDataUpdatedFlag]);

    return (
        <div>
            <Segmented
                value={activeTab}
                onChange={(value) => setActiveTab(String(value))}
                options={[
                    {
                        label: `Invoices (${invoicesCount})`,
                        value: 'invoices',
                    },
                    {
                        label: `Drafts (${draftsCount})`,
                        value: 'drafts',
                    },
                ]}
                className={s.segmented}
            />
            {activeTab === 'invoices' && (
                <div className={useForModule ? undefined : s.wrap}>
                    <PaymentTable clientId={clientId} isGroupPractice={isGroupPractice} />
                </div>
            )}
            {activeTab === 'drafts' && (
                <div className={useForModule ? undefined : s.wrap}>
                    <InvoiceDraftTable clientId={clientId} state={state} onDataChange={refreshCounts} isGroupPractice={isGroupPractice} />
                </div>
            )}
        </div>
    );
};

export default Billing;
